import { inject } from 'vue'

export const AlertSymbol = Symbol('rs-alert')

export function useAlert() {
  const Alert = inject(AlertSymbol)
  if (!Alert) {
    throw new Error('No alert provided!')
  }

  return Alert
}
